/* -----------------------------------------------------------------------------
 * runtime config
 *
 * Injected by vite.config.mts from .env.<mode>.local. Replaces the ENV of
 * @walrus/common, which also merged user-agent data for tracking.
 * -------------------------------------------------------------------------- */

declare const __ENV__: {
  flipper_url: string
  flipper_ws_url: string
  bugsnag_token: string
  target: 'dev' | 'staging' | 'prod'
  release_version: string
  app_name: 'professional'
  client_type: 'web'
  platform_type: 'web'
}

// phones only, as ua-parser-js reported them: tablets and desktops are not 'mobile'
const deviceType = /Mobi/i.test(navigator.userAgent) ? 'mobile' : undefined

export const ENV = { ...__ENV__, device_type: deviceType }
